import React from 'react';

import { Dropdown } from 'design/dropdown';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { SelectControlOption, PageSize, PageSizeString } from 'types/state';
import {
  normalizePageSize,
  normalizePageSizeString,
} from 'utils/normalizePageSize';

type TProps = {
  value: PageSize;
  onValueChange(nextValue: PageSize): void;
};

export const PageSizeControl = (props: TProps) => {
  const { value, onValueChange } = props;

  const intl = useIntlDictionary();

  const options: Array<SelectControlOption<PageSizeString>> = React.useMemo(
    () => [
      {
        title: intl.pageSizeLabel(20),
        value: normalizePageSize(20).toPageSizeString(),
      },
      {
        title: intl.pageSizeLabel(50),
        value: normalizePageSize(50).toPageSizeString(),
      },
      {
        title: intl.pageSizeLabel(100),
        value: normalizePageSize(100).toPageSizeString(),
      },
    ],
    [intl]
  );

  const handleSelect = React.useCallback(
    (selectedValue: PageSizeString) => {
      onValueChange(normalizePageSizeString(selectedValue).toPageSize());
    },
    [onValueChange]
  );

  const selected = normalizePageSize(value).toPageSizeString();

  return (
    <Dropdown
      options={options}
      selectedValue={selected}
      onSelectValue={handleSelect}
    />
  );
};
